module.exports = __webpack_public_path__ + "static/no_data_icon.8434dfa5.png";